/* eslint-disable no-undef */
export const configuration = {
  AWS_REGION: process.env.AWS_REGION,
  AWS_USER_POOL_ID: process.env.AWS_USER_POOL_ID,
  AWS_USER_POOL_WEB_CLIENT_ID: process.env.AWS_USER_POOL_WEB_CLIENT_ID,
  AWS_APPSYNC_AUTHENTICATIONTYPE: process.env.AWS_APPSYNC_AUTHENTICATIONTYPE,
  AWS_APPSYNC_GRAPHQLENDPOINT_GETDATA:
    process.env.AWS_APPSYNC_GRAPHQLENDPOINT_GETDATA,
};
